import React from "react";
import { PageHero, SectionLabel, Reveal, ArrowLink, Stat } from "../components/common";
import { CtaBand } from "./Home";
import { IMG, ROADMAP, PRINCIPLES } from "../mock";

export default function About() {
  return (
    <main>
      <PageHero
        index="01"
        eyebrow="A Garry Industries Ventures · About & Vision"
        title="A platform for the future of railway infrastructure."
        subtitle="Railway Machines is being built to become a globally respected railway machinery OEM — designing, engineering, manufacturing and supporting a complete ecosystem of intelligent railway technologies."
        image={IMG.yellowMachine}
      />

      {/* Vision */}
      <section className="bg-[#f2f1ec] text-[#0a0a0a] py-24 md:py-32">
        <div className="mx-auto max-w-[1400px] px-5 md:px-10">
          <div className="grid gap-12 lg:grid-cols-[0.8fr_1.2fr] lg:gap-20">
            <Reveal><SectionLabel light>A Garry Industries Ventures · Our Vision</SectionLabel></Reveal>
            <div>
              <Reveal><p className="font-display text-2xl md:text-3xl font-medium leading-snug">To build an integrated engineering platform that maintains, inspects and modernises railway infrastructure — combining heavy machinery, robotics and artificial intelligence into a single, coherent ecosystem.</p></Reveal>
              <Reveal delay={120}><p className="mt-8 text-[#4a4a44] leading-relaxed max-w-2xl">We believe the next era of railways will be defined by machines that not only perform physical work with precision, but also sense, learn and predict. As a Garry Industries venture, our ambition is to engineer that future from India, for the world.</p></Reveal>
            </div>
          </div>
        </div>
      </section>

      {/* Roadmap */}
      <section className="relative bg-[#0a0a0a] py-24 md:py-32">
        <div className="dot-grid absolute inset-0 opacity-25 pointer-events-none" />
        <div className="relative mx-auto max-w-[1400px] px-5 md:px-10">
          <Reveal><SectionLabel>A Garry Industries Ventures · The Roadmap</SectionLabel></Reveal>
          <Reveal><h2 className="font-display mt-6 text-4xl md:text-5xl lg:text-6xl font-bold leading-[1.02] tracking-tight max-w-2xl">A deliberate path, engineered in phases.</h2></Reveal>
          <div className="mt-16 grid gap-px bg-white/10 md:grid-cols-2 lg:grid-cols-5">
            {ROADMAP.map((r, i) => (
              <Reveal key={i} delay={i * 70} className="group bg-[#0a0a0a] p-7 hover:bg-[#111] transition-colors">
                <div className="font-mono2 text-[#c3e63c] text-sm">{r.n}</div>
                <div className="mt-4 h-px w-full bg-white/10" />
                <h3 className="font-display mt-5 text-lg font-semibold">{r.title}</h3>
                <p className="mt-3 text-sm leading-relaxed text-neutral-400">{r.desc}</p>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      {/* Principles */}
      <section className="bg-[#f2f1ec] text-[#0a0a0a] py-24 md:py-32">
        <div className="mx-auto max-w-[1400px] px-5 md:px-10">
          <Reveal><SectionLabel light>A Garry Industries Ventures · Principles</SectionLabel></Reveal>
          <Reveal><h2 className="font-display mt-6 text-4xl md:text-5xl lg:text-6xl font-bold leading-[1.02] tracking-tight">What we hold ourselves to.</h2></Reveal>
          <div className="mt-16 grid gap-px bg-[#d8d7d0] sm:grid-cols-2 lg:grid-cols-3">
            {PRINCIPLES.map((p, i) => (
              <Reveal key={i} delay={i * 60} className="group bg-[#f2f1ec] p-8 hover:bg-white transition-colors">
                <div className="font-mono2 text-[#8ba817] text-sm">{p.n}</div>
                <h3 className="font-display mt-4 text-xl font-semibold">{p.title}</h3>
                <p className="mt-3 text-sm leading-relaxed text-[#4a4a44]">{p.desc}</p>
              </Reveal>
            ))}
          </div>
          <div className="mt-14"><ArrowLink to="/engineering" light>See our engineering approach</ArrowLink></div>
        </div>
      </section>

      <CtaBand />
    </main>
  );
}
